module.exports = __webpack_public_path__ + "static/img/icon1-2.55672032.svg";